import {gsap, TweenLite} from "gsap";
import {Sprite} from "pixi.js";
import {FireInTheHole2} from "../FireInTheHole2";
import {FITH2SoundManager} from "../sound/FITH2SoundManager";

export class ReelTopBar extends PIXI.Container {
    private BAR_BASE_POSITION: number = 355;
    private _barId: number = 0;
    private _bar: Sprite;

    constructor() {
        super();
        this.name = "ReelTopBar";
        this.init();
        this.position.set(0, 0)
    }

    private init() {
        this._bar = new PIXI.Sprite(FireInTheHole2.assetLoader.getTextures("barrier")[0]);
        this._bar.anchor.set(0, 0);
        this._bar.position.set(-18, this.BAR_BASE_POSITION);

        const mainReelsMask: PIXI.Graphics = new PIXI.Graphics();
        mainReelsMask.name = "symbolMask";
        mainReelsMask.beginFill(0xFFFF0B, 0.5);
        mainReelsMask.drawRect(-18, this.BAR_BASE_POSITION-16, this._bar.width, this._bar.height);
        this.addChild(this._bar, mainReelsMask);
        this.mask = mainReelsMask;
    }

    public reset(): void {
        if (this._bar.position.y != this.BAR_BASE_POSITION) {
            this._barId = 0;
            FITH2SoundManager.playSound("gridReset");
            TweenLite.to(this._bar, 0.5, {y: this.BAR_BASE_POSITION});
        }
    }

    public updateBarsOnRestore(): void {
        this.barId = Math.min(6, FireInTheHole2.model.barId);
        this.updateBars();
    }

    public updateBars(): gsap.core.Timeline {
        const toPosition: number = this.BAR_BASE_POSITION + (this._barId - 2) * 100;
        if (this._bar.position.y === toPosition) {
            return gsap.timeline();
        }
        const fps: number = 30,
            initialDurFrames: number = 12 / fps,
            midDurFrames: number = 1 / fps,
            endDurFrames: number = 2 / fps;

        // #32


        return gsap.timeline().add([
            () => {
                    FireInTheHole2.reelArea.addDirtFrames(true);
                    FITH2SoundManager.playSound(`gridDown`);
            },
            TweenLite.to(this._bar, initialDurFrames, {
                y: toPosition+2,
                onComplete: () =>{
                    TweenLite.to(this._bar, midDurFrames, {
                        y: toPosition-2,
                        onComplete: () => {
                            TweenLite.to(this._bar, endDurFrames, {y: toPosition});
                        }
                    });
                }
            })
        ]);
    }

    public setMode(mode: string): void {
        this._bar.visible = mode[0] === "N";
    }

    public show(): void {
        this._bar.visible = true;
    }

    public hide(): void {
        this._bar.visible = false;
    }

    //barId will start with 3->2->1->0
    public set barId(value) {
        this._barId = value;
    }

    public get barId(): number {
        return this._barId;
    }
}